export const getMonthString = (numberAsString) => {
  const number = parseInt(numberAsString, 10);

  if (isNaN(number)) {
    return "Invalid Input";
  }

  return number === 1 ? "1 Month" : `${number} Months`;
};